import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import Tour from 'reactour';
import { createStructuredSelector } from 'reselect';
import TextButton from 'components/TextButton';
import { clearOnboardTour, getOnboardTour } from 'utils/localStorage';
import FreePlayIcon from 'resources/Free_Play_Icon.png';
import GamesIconSVG from 'resources/FeatureIcons/Button-Games.svg';
import RadialPageOne from 'resources/radial_1.png';
import RadialPageThree from 'resources/radial_3.png';
import RadialPageTwo from 'resources/radial_2.png';
import StarsBackground from 'resources/stars_background.png';
import StarsBackgroundSpaced from 'resources/stars_background_spaced.png';
import WStoreIconSVG from 'resources/FeatureIcons/Button-WStore.svg';
import { setOnboardActive } from './actions';
import { selectOnboardActive } from './selectors';
import './OnboardTour.css';

const OnboardTour = ({ setOnboardActive, onboardActive }) => {
  const [currentStep, setCurrentStep] = useState(0);

  useEffect(() => {
    if (getOnboardTour()) {
      setOnboardActive(true);
    }
  });

  const handleCloseOnboard = () => {
    setOnboardActive(false);
    setCurrentStep(0);
    clearOnboardTour();
  };

  const handleNextStep = () => {
    if (currentStep < steps.length - 1) {
      const newStep = currentStep + 1;
      setCurrentStep(newStep);
    }
  };

  const handlePrevStep = () => {
    if (currentStep > 0) {
      const newStep = currentStep - 1;
      setCurrentStep(newStep);
    }
  };

  const NextButton = (
    <TextButton className="next-button" onClick={handleNextStep}>
      NEXT
    </TextButton>
  );
  const PrevButton = (
    <TextButton className="prev-button" onClick={handlePrevStep}>
      BACK
    </TextButton>
  );
  const FinishButton = (
    <TextButton className="next-button" onClick={handleCloseOnboard}>
      LET'S PLAY!
    </TextButton>
  );

  const steps = [
    {
      key: 'step1',
      content: (
        <div className="onboard-content">
          <img className="stars-background-1" alt="" src={StarsBackground} />
          <img className="radial-background" alt="" src={RadialPageOne} />
          <img className="games-icon" alt="" src={GamesIconSVG} />
          <div className="onboard-title">Welcome to Wind Creek Online.</div>
          <div className="onboard-subtitle">Find Your Winning Moment.</div>
          <div className="onboard-text">
            {'Play games and earn currency to redeem amazing '}
            {'offers at your favorite Wind Creek property'}
          </div>
          <div className="onboard-buttons">{NextButton}</div>
        </div>
      )
    },
    {
      key: 'step2',
      content: (
        <div className="onboard-content">
          <img
            className="stars-background-2"
            alt=""
            src={StarsBackgroundSpaced}
          />
          <img className="radial-background" alt="" src={RadialPageTwo} />
          <img className="wstore-icon" alt="" src={WStoreIconSVG} />
          <div className="onboard-title">Play. Earn. Redeem.</div>
          <div className="onboard-text">
            {'You can redeem your currency anytime for all sorts of '}
            {"offers. When you're ready, visit the WStore and choose "}
            {"the offer that's best for you!"}
          </div>
          <div className="onboard-buttons">
            {PrevButton}
            {NextButton}
          </div>
        </div>
      )
    },
    {
      key: 'step3',
      content: (
        <div className="onboard-content">
          <img className="stars-background-3" alt="" src={StarsBackground} />
          <img className="radial-background" alt="" src={RadialPageThree} />
          <img className="freeplay-icon" alt="" src={FreePlayIcon} />
          <div className="onboard-title">
            Visit Your Favorite Wind Creek Property.
          </div>
          <div className="onboard-text">
            {"Once you've redeemed your offers simply card in at "}
            {'your favorite Wind Creek property and use your offers. '}
            {"Once you're back home you can start earning again!"}
          </div>
          <div className="onboard-buttons">
            {PrevButton}
            {FinishButton}
          </div>
        </div>
      )
    }
  ];

  return (
    onboardActive && (
      <Tour
        className="onboard-tour"
        steps={steps}
        isOpen={onboardActive}
        onRequestClose={handleCloseOnboard}
        goToStep={currentStep}
        showButtons={false}
        showNavigation={false}
        showNumber={false}
      />
    )
  );
};

const mapStateToProps = createStructuredSelector({
  onboardActive: selectOnboardActive()
});

const mapDispatchToProps = dispatch => ({
  setOnboardActive: active => dispatch(setOnboardActive(active))
});

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export default withConnect(OnboardTour);
